// Solufy Cookie Consent Banner & Visitor Detail Tracking

function getCookie(name) {
	const matches = document.cookie.match(
		new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"),
	);
	return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setCookie(name, value, days = 365) {
	const expires = new Date(Date.now() + days * 864e5).toUTCString();
	document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
}

function sendVisitorDetails(consentStatus) {
 document.dispatchEvent(new CustomEvent("solufy:consent-changed", { detail: consentStatus }));
}

export function mountCookieBanner(root = document) {
	const existingConsent = getCookie("solufy_consent");

	// If already consented previously, send background session log
	if (existingConsent) {
		sendVisitorDetails(existingConsent);
		return () => {};
	}

	// Avoid duplicate banner
	if (document.querySelector(".solufy-cookie-banner")) {
		return () => {};
	}

	const banner = document.createElement("div");
	banner.className = "solufy-cookie-banner";
	banner.setAttribute("role", "dialog");
	banner.setAttribute("aria-modal", "false");
	banner.setAttribute("aria-label", "Cookie preferences");

	banner.innerHTML = `
		<div class="scb__inner">
			<!-- Left: icon + copy -->
			<div class="scb__left">
				<div class="scb__icon" aria-hidden="true">
					<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
						<path d="M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5"/>
						<path d="M8.5 8.5v.01"/><path d="M16 15.5v.01"/><path d="M12 12v.01"/>
						<path d="M11 17v.01"/><path d="M7 13v.01"/>
					</svg>
				</div>
				<div class="scb__copy">
					<strong class="scb__title">Cookie Notice</strong>
					<p class="scb__desc">We use cookies to enhance your experience and analyze traffic.</p>
				</div>
			</div>

			<!-- Centre: manage link (desktop only) -->
			<button type="button" class="scb__manage-link scb__manage-link--desktop">Manage preferences</button>

			<!-- Right: action buttons -->
			<div class="scb__actions">
				<button type="button" class="scb__btn scb__btn--essential">Essential Only</button>
				<button type="button" class="scb__btn scb__btn--accept">Accept</button>
			</div>

			<!-- Close button (mobile only) -->
			<button type="button" class="scb__close" aria-label="Dismiss">
				<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
					<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
				</svg>
			</button>
		</div>

		<!-- Mobile-only stacked bottom area -->
		<div class="scb__mobile-actions">
			<button type="button" class="scb__btn scb__btn--accept scb__btn--full">Accept All</button>
			<button type="button" class="scb__btn scb__btn--essential scb__btn--full scb__btn--ghost">Essential Only</button>
			<button type="button" class="scb__manage-link">Manage preferences</button>
		</div>
	`;

	document.body.appendChild(banner);

	// Animate in
	requestAnimationFrame(() => {
		banner.classList.add("is-visible");
	});

	const removeBanner = () => {
		banner.classList.remove("is-visible");
		banner.classList.add("is-closing");
		setTimeout(() => banner.remove(), 380);
	};

	// Wire up all accept buttons
	banner.querySelectorAll(".scb__btn--accept").forEach(btn => {
		btn.addEventListener("click", () => {
			setCookie("solufy_consent", "Accepted", 365);
			try { localStorage.setItem("solufy_consent", "Accepted"); } catch (e) {}
			sendVisitorDetails("Accepted");
			removeBanner();
		});
	});

	// Wire up all essential buttons
	banner.querySelectorAll(".scb__btn--essential").forEach(btn => {
		btn.addEventListener("click", () => {
			setCookie("solufy_consent", "Essential Only", 365);
			try { localStorage.setItem("solufy_consent", "Essential Only"); } catch (e) {}
			sendVisitorDetails("Essential Only");
			removeBanner();
		});
	});

	// Manage preferences — just dismiss for now
	banner.querySelectorAll(".scb__manage-link").forEach(btn => {
		btn.addEventListener("click", () => {
			setCookie("solufy_consent", "Essential Only", 365);
			try { localStorage.setItem("solufy_consent", "Essential Only"); } catch (e) {}
			sendVisitorDetails("Essential Only");
			removeBanner();
		});
	});

	// Close / dismiss
	banner.querySelector(".scb__close")?.addEventListener("click", removeBanner);

	return () => banner.remove();
}
